export const ManageProcessOrderStatusEnum = {
  OPEN: 'Open',
  CLOSED: 'Closed',
};
export const CreateEditDupOrderEnum = {
  NEW: '0',
  EDIT: '1',
  DUP: '2',
};
export const StatusOptionEnum = {
  OPEN: 'O',
  CLOSED: 'C',
};
export const TypeOptionEnum = {
  ORDER: 'O',
};
export const TabEnum = {
  ProcessOrder: 'ProcessOrder',
  PurchaseOrder: 'PurchaseOrder',
};


export const BracketTypeEnum = {
  None: 0,
  Dollars: 1,
  Weight: 2,
  Quantity: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ManageProcessOrderEnum.js